<template>
  <div v-if="existTask">
    <router-link class="f messages el-badge" to="">
      <div id="showExportBtn" @click="shrink">
        <i class="el-icon-download"></i>
        下载列表
        <sup v-show="existTask" class="el-badge__content el-badge__content&#45;&#45;undefined is-fixed" style="top: 17px">{{ tasks? tasks.length : 0 }}</sup>
      </div>
    </router-link>

    <el-popover
      placement="bottom"
      width="300"
      trigger="manual"
      id="exportFilePopover"
      style="margin-top: 15px"
      v-model="isHidden">
      <el-row style="padding-top: 10px; font-weight: bold;">
        <el-col :span="12" style="color: #909399">
          文件下载列表
        </el-col>
        <el-col :span="12" style="text-align: right" v-if="existTask">
          <el-popconfirm title="确定清空全部任务吗？" @onConfirm="closeAll()">
            <!--            @click="closeAll"-->
            <el-button  slot="reference" type="text" style="padding: 0px" >清空全部</el-button>
          </el-popconfirm>
        </el-col>
        <el-divider style="margin: 0px !important;"></el-divider>
      </el-row>
      <div id="tasksDiv" v-if="existTask" >
        <p class="df" style="margin-bottom: 10px;" v-for="row in this.tasks">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAASUlEQVQYV3XNwQmAMBAEwMnHtxVqB/rSInwZS7DBWIIcGpCA+znY4diEDhsGT06sCTvmt6wnBxT0DVx/UAIypubjCKjj42d8uQErigsRrcHQ3gAAAABJRU5ErkJggg==" class="list_round">
          <span>
          <span class="flexdc" style="font-size: 14px; line-height: 14px; margin-bottom: 6px;" v-html="row.fileName">2021_企业培训档案</span>
          <span>
            <template v-if="row.taskState ==  exportFileConstant.taskStatus.processing">
               <!--处理成功-->
                <span style="color: #e6a23c;">处理中</span>
            </template>
            <template v-if="row.taskState ==  exportFileConstant.taskStatus.sucess">
                <!--处理成功-->
                <span class="success_color">已完成</span>
              <!--处理失败-->
                <span class="load_fail_btn">
                  <a :href="row.downloadURL" class="nodrag el-link el-link--primary is-underline" style="margin-left: 10px;"><span class="el-link--inner">下载</span></a>
                </span>
            </template>
            <template v-if="row.taskState == exportFileConstant.taskStatus.failure">
               <!--处理成功-->
              <span style="color: #f56c6c">失败</span>
              <!--处理失败-->
               <span class="load_fail_btn">
                   <el-tooltip class="item" effect="dark" :content="row.errorMsg" placement="top-start">
                       <el-link type="danger" :underline="false">失败描述</el-link>
                   </el-tooltip>
              </span>
            </template>
            </span>
          </span>
        </p>
      </div>
      <emptyContainer v-if="!existTask"></emptyContainer>
    </el-popover>
  </div>
</template>

<script>
import exportApi from "@/api/training/api_export";
import $exportFileConstant from '@/pages/trainingManagement/component/exportFile/exportFileConstant'
import {bus} from "../../../../bus";
import emptyContainer from "@/components/emptyContainer";

export default {
  name: "exportFile",
  components: {emptyContainer},
  data() {
    return {
      tasks: [],  // 任务列表
      id: 1,
      isHidden: false,
      refreshAsyncTasksStatusInterval: undefined,
      exportFileConstant: $exportFileConstant
    }
  },
//自定义指令
  directives:{
    drag(el){
      el.onmousedown = function (e) {
        var disx = e.pageX - el.offsetLeft;
        var disy = e.pageY - el.offsetTop;
        document.onmousemove = function (e) {
          el.style.left = e.pageX - disx + 'px';
          el.style.top = e.pageY - disy + 'px';
        }
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null;
        }
      }
    }
  },
  methods: {
    /**
     * put 一个任务  （组件提供的api ）
     */
    putAsyncTask(param) {
      this.asyncTaskRequest([param]);
    },
    /**
     * put 一组任务
     */
    putAsyncTasks(params) {
      this.asyncTaskRequest(params);
    },
    /**
     *  发送 异步任务请求 并且 处理 异步任务请求
     * */
    asyncTaskRequest(files) {
      let param = {
        files:  files
      }
      exportApi.async(param).then(res => {
        if (!this.tasks) {
          this.tasks = [];
        }
        let files = res.data.files;
        this.tasks.push(...files)
        console.log('then tasks length---- %o', this.tasks.length)
        this.runRefreshAsyncTasksStatusInterval();
        // //发布put异步任务成功时间
        bus.$emit('putAsyncTasksSucess')
        //只要 put 任务我们就展示 下载框
        this.isHidden = true;
      }).catch((error) =>  {
        console.log('error msg %o', error)
        this.$message.error({
          showClose: true,
          message:  error.response.data.message,
          duration: 2000
        });
        bus.$emit('putAsyncTasksError',  error.response.data.message)
      });
    },
    /**
     * 当 notify  关闭时调用的回调
     */
    closeAll() {
      this.closeRefreshAsyncTasksStatusInterval();
      this.tasks = [];
    },
    /**
     * 是否隐藏
     **/
    shrink() {
      this.isHidden = !this.isHidden;
    },
    /**
     * 刷新异步任务状态
     */
    refreshAsyncTasksStatus() {
      let processingTasks = this.tasks
        .map((obj, index) => {
          let mapItemObj = obj;
          mapItemObj.index = index;
          return [obj.taskId, mapItemObj];
        }).filter(obj => $exportFileConstant.taskStatus.processing == obj[1].taskState);
      if (processingTasks && processingTasks.length > 0) {
        let processingTasksMap = new Map(processingTasks);
        let param = {
          taskIds: processingTasks.map(obj => obj[1].taskId)
        }
        exportApi.asyncStatus(param).then(res => {
          if (res.data.files && res.data.files.length > 0) {
            res.data.files.forEach(obj => {
              let task = processingTasksMap.get(obj.taskId);
              if (task.taskState != obj.taskState) {
                this.$set(this.tasks, task.index, obj);
              }
            })
          }
        }).catch((error) => {
          console.log('error msg %o', error)
          this.$message.error({
            showClose: true,
            message: error.message,
            duration: 2000
          });
        });
      }
    },
    /**
     * 开启 定时刷新异步任务状态  定时器  （间隔时间 1 秒）
     **/
    runRefreshAsyncTasksStatusInterval() {
      if (this.refreshAsyncTasksStatusInterval) {
        return;
      }
      this.refreshAsyncTasksStatusInterval = window.setInterval(() => {
        this.refreshAsyncTasksStatus();
      }, 1 * 1000)
    },
    /**
     * 关闭刷新异步任务状态
     */
    closeRefreshAsyncTasksStatusInterval() {
      window.clearInterval(this.refreshAsyncTasksStatusInterval);
      this.refreshAsyncTasksStatusInterval = undefined;
    }
  },
  created() {
    bus.$on('putAsyncTask', (param) => {
      this.putAsyncTask(param);
    });
    bus.$on('putAsyncTasks', (param) => {
      this.putAsyncTasks(param);
    });

    document.addEventListener("click",e=>{
      let box = document.getElementById("exportFilePopover");
      let showExportBtn = document.getElementById("showExportBtn");
      if (box != null && box != undefined && showExportBtn != null  && showExportBtn != undefined) {
        if(!box.contains(e.target) && !showExportBtn.contains(e.target)){
          this.isHidden =  false;
        }
      }
    });

  },
  mounted() {
    // this.tasks.push({
    //   taskId: 1,
    //   taskState: $exportFileConstant.taskStatus.sucess,
    //   fileName: 'xxx.doc',
    // })
    // this.tasks.push({
    //   taskId: 1,
    //   taskState: $exportFileConstant.taskStatus.failure,
    //   fileName: 'aaa.doc',
    //   errorMsg: '下载失败了11·1'
    // })
    // this.tasks.push({
    //   taskId: 1,
    //   taskState: $exportFileConstant.taskStatus.processing,
    //   fileName: 'bb.doc',
    // })
  },
  computed: {
    existTask() {
      return this.tasks && this.tasks.length > 0;
    }
  }
}
</script>

<style scoped>
.df, .flexdc {
  display: flex;
  overflow: hidden;
}

.list_round {
  width: 6px;
  height: 6px;
  position: relative;
  top: 4px;
  left: 7px;
  margin-right: 17px;
}

.success_color {
  color: #00bd16;
}

.load_fail_btn {
  background-color: #f2f7fd;
  line-height: 14px;
  font-size: 14px;
  display: inline-block;
  margin-left: 13px;
  padding: 5px 8px;
  color: #5b6be7;
  border-radius: 20px;
}

.download-notify .hiddenBtn {
  position: absolute;
  /*top: 22px;*/
  /*right: 40px;*/
  cursor: pointer;
  color: #909399;
  font-size: 16px;
  z-index: 100000000000000!important;
}


.download-notify .hiddenBtn {
  position: absolute;
  top: 22px;
  right: 40px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.download-notify {
  z-index: 100;
}

#tasksDiv {
  overflow-y: auto;
  height: 330px;
  overflow-x: hidden;
}


::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-button {
  display: none;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}


::-webkit-scrollbar-thumb {
  background-color: #93c7f5;
  border-radius: 9px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-track-piece {
  background: linear-gradient(90deg, #d8d9de, #e6e8ec);
  background: -webkit-linear-gradient(90deg, #d8d9de, #e6e8ec);
  border-radius: 9px;
}

/* nav style*/
.messages {
  margin-right: 20px;
  color: #fff;
}

.messages i {
  font-size: 20px;
  margin-right: 6px;
}

</style>





// WEBPACK FOOTER //
// src/pages/trainingManagement/component/exportFile/exportFile.vue